/**
 * @(#)2019/7/15.
 * YxRadio，可以进行单选
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import ReactDOM from "react-dom";
import Utils, { get } from "../../utils";
import IconRadio from "./IconRadio";
import Basics from "./Basics";
import { Radio, Button } from "antd";
import { YxComponent, Connection } from "../YxComponent";
import { set, cloneDeep, isEqual, merge } from "lodash";
import { IRadioPropTypes } from "./IpropType/radioPropType";
//默认props
/*
 * @param type {enum} 控件类型 group/""  分组/单个
 * @param data {array} 分组数据 buttonStyle 为icon 时候data 中可以配置icon 和 src （默认图片），srcSelected（选中图片）
 * @param children {object}子节点暂时只支持antd的Radio
 * @param buttonStyle {string} 设置为按钮风格样式，目前有描边和填色两种风格	outline | solid | icon，默认outline， 当type='group'时生效
 * @param styleParam {object} 样式参数
 * @param styleParam.size {string} 大小，暂时只支持default
 * @param styleParam.type {string} 类型，暂时只支持default
 * */
let defaul = () => {
  return {
    inputParam: {},
    children: "", //子节点,子节点暂时只支持antd的Checkbox
    type: "group", //类型，分组模式
    data: [], //分组的数据
    rules: {
      max: "",
    },
    styleParam: {
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class YxRadio extends YxComponent {
  constructor(props) {
    super(props);
  }
  productionHtml() {
    // 重新修改defaultValue 给外部元素获取
    let tmpProps = { ...this.props };

    tmpProps.rules.max = "";
    if (tmpProps.type == "group") {
      // 新增icon 类型
      if (tmpProps.buttonStyle) {
        let group = () => (
            <Radio.Group
              buttonStyle={
                tmpProps.buttonStyle === "solid" ? "solid" : "outline"
              }
            >
              {tmpProps.data.map((val) => (
                <Radio.Button value={val.key || val.value}>
                  {val.label}
                </Radio.Button>
              ))}
            </Radio.Group>
          ),
          children = "";

        if (tmpProps.buttonStyle == "icon") {
          set(tmpProps, "styleParam.size", "icon");
          set(tmpProps, "styleParam.type", "icon");
          set(tmpProps, "getFieldDecoratorParam.valuePropName", "value");
          set(tmpProps, "getFieldDecoratorParam.validateTrigger", "change");
          set(tmpProps, "getFieldDecoratorParam.trigger", "change");
          children = <IconRadio {...tmpProps} />;
        } else {
          children = group();
        }

        tmpProps.children = children;
      } else {
        tmpProps.children = (
          <Radio.Group options={tmpProps.data} buttonStyle="solid">
            {tmpProps.children || ""}
          </Radio.Group>
        );
      }
    } else {
      tmpProps.children = <Radio>{tmpProps.children}</Radio>;
    }
    let classParam = {
      yx_yxRadio_: "styleParam.type",
      yx_yxRadio_size_: "styleParam.size",
    };

    set(
      tmpProps,
      "inputParam.className",
      this.styleParamClassName(tmpProps, classParam)
    );
    let html = Basics.html(tmpProps);
    return html;
  }
  render() {
    return this.productionHtml();
  }
}

YxRadio.propTypes = IRadioPropTypes;
YxRadio.defaultProps = defaul();

export default YxRadio;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxRadio.js